const roleMap = { 1: "Admin", 2: "Manager", 3: "Staff", 4: "Cashier" };
// Stable application package IDs. The database package names are mapped to these IDs by the API.
const packageMap = { 1: "Dine-In Classic", 2: "Counter Express", 3: "Catalog Plan", 4: "Smart Ultimate", 5: "Takeaway" };
const diet = { 1: "Veg", 2: "Non-Veg", 3: "Vegan", 4: "Egg" };
const dietTaste = { 1: "Spicy", 2: "Bestseller", 3: "Gluten-Free", 4: "Sweet", 5: "No Onion Garlic", 6: "New",
  7:"Chef Special", 8:"Jain", 9:"Dry", 10:"Gravy"};
const dietToFoodTypeId = { Veg: 1, 'Non-veg': 2, Vegan: 3,  Egg:4};
const OrderStatus = {
  0: "Pending",
  1: "Preparing",
  2: "Ready",
  3: "Served",
  4: "Cancelled"
};

const statusMap = { 0: "Empty", 1: "Occupied", 2: "Reserved", 3: "Maintenance", 4: "BillingRequested" };

const reverseStatusMap = { "Empty": 0, "Occupied": 1, "Reserved": 2, "Maintenance": 3, "BillingRequested": 4 };




export { roleMap, diet, OrderStatus, statusMap, reverseStatusMap, packageMap, dietTaste }
